import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";

const LatestComplaintsSection = ({ data }) => {
  const [Data, setData] = useState({
    totalComplaints: 0,
    totalPending: 0,
    totalResolved: 0,
    assigned: 0,
  });

  useEffect(() => {
    if (data && typeof data === "object") {
      setData((prev) => ({
        ...prev,
        ...data,
      }));
    }
  }, [data]);

  return (
    <BookingSummary>
      <BookingGrid>
        <BoxComp
          value={Data.totalComplaints}
          title="Total Complaints"
          className="bg-indigo-50 text-indigo-400 border-b-indigo-400"
        />
        <BoxComp
          value={Data.totalPending}
          title="Total Pending"
          className="bg-rose-50 text-rose-400 border-b-rose-400"
        />
        <BoxComp
          value={Data.totalResolved}
          title="Resolved Complaints"
          className="bg-blue-50 text-blue-400 border-b-blue-400"
        />
        <BoxComp
          value={Data.assigned}
          title="Assigned Complaints"
          className="bg-amber-50 text-amber-400 border-b-amber-400"
        />
      </BookingGrid>
    </BookingSummary>
  );
};

const BoxComp = ({ value, title, className }) => (
  <Box className={`border-b-4 shadow-xl ${className}`}>
    <BoxTitle>
      {title}
      <hr className={`${className} w-1/3 border-b-2 rounded-full`} />
    </BoxTitle>
    <BoxCount>{value || 0}</BoxCount>
  </Box>
);

const BookingSummary = tw.div``;
const BookingGrid = tw.div`grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-6 mt-6`;
const Box = tw.div`w-full min-h-32 rounded-lg shadow-md flex flex-col p-4 justify-between relative hover:scale-105 transition`;
const BoxTitle = tw.h3`text-sm sm:text-md lg:text-md font-medium uppercase text-zinc-500 font-semibold mb-2`;
const BoxCount = tw.p`font-semibold xl:text-[26px] text-[32px] mt-auto`;

export default LatestComplaintsSection;